module.exports = __webpack_public_path__ + "cef964b1208d91b91b1ccbb6f2d650e8.jpg";